import { render, staticRenderFns } from "./LabResultsWizard.vue?vue&type=template&id=afa1d626&scoped=true&"
import script from "./LabResultsWizard.vue?vue&type=script&lang=js&"
export * from "./LabResultsWizard.vue?vue&type=script&lang=js&"
import style0 from "./LabResultsWizard.vue?vue&type=style&index=0&id=afa1d626&scoped=true&lang=css&"
import style1 from "./LabResultsWizard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa1d626",
  null
  
)

export default component.exports